import React from "react";
import s from "./MenuBlock.module.css";
import img from "../data/images/MenuBlock@2x.png";

export default function MenuBlock({ onChangeValue }) {
  const handleClick = (event) => {
    onChangeValue(event.target.value);
  };

  return (
    <div
      className={`row justify-content-center flex-sm-column flex-sm-column-reverse flex-lg-row flex-lg-row-reverse ${s.innerRow} ${s.menuWrapper}`}
    >
      <img
        className={`col-sm-12 col-lg-5 ${s.img}`}
        src={img}
        alt="User interface at private computer"
      />
      <div className={`col-sm-12 col-lg-6 ${s.menu}`}>
        <div
          className={`row justify-content-center align-items-center ${s.tubsWrapper}`}
        >
          <button
            className={s.activeTub}
            value="1"
            type="button"
            onClick={handleClick}
          />
          <button
            className={s.tub}
            value="0"
            type="button"
            onClick={handleClick}
          />
        </div>

        <div className={`row ${s.innerContentRow}`}>
          <h2 className={`col-sm-12 col-lg-12 ${s.title}`}>
            הקמה מהירה של הרשאה לחיוב חשבון
          </h2>
          <p className={`col-sm-12 col-lg-12 ${s.text}`}>
            התהליך כולו לוקח כ-5 דקות ומומלץ להתחילו ממחשב
            <br/> ולא מטלפון נייד
          </p>
        </div>
        <div className={`row ${s.innerBtnRow}`}>
          <button
            className={`col-sm-6 col-lg-6 ${s.btnNext}`}
            value="0"
            type="button"
            onClick={handleClick}
          >
            ממשיכים
          </button>
        </div>
      </div>
    </div>
  );
}
